export const TOKEN = 'authToken';
export const COMPANY_LOGO = 'companyLogo';